const SiteGeneral = {
	OnReady: () => {
		(function ($) {
			const menuToggle = document.querySelector('.menu-toggle');
			const mobileMenu = document.querySelector('.mobile-nav');

			// Guard: these may not exist on every layout — without this the
			// whole main.js bundle would throw and stop (breaking scroll
			// animations, the newsletter handler, etc.).
			if (menuToggle && mobileMenu) {
				menuToggle.addEventListener('click', () => {
					const isActive = mobileMenu.classList.toggle('open');
					menuToggle.classList.toggle('active', isActive);
				});
			}

			$('#newsletter-ajax-form').on('submit', function (e) {
				e.preventDefault();

				var form = $(this);
				var email = form.find('input[name="newsletter_email"]').val();

				$.ajax({
					url: newsletter_ajax.ajax_url,
					type: 'POST',
					data: {
						action: 'newsletter_submit',
						email: email,
						security: newsletter_ajax.nonce,
					},
					success: function (response) {
						if (response.success) {
							// hide heading
							$('#newsletter-heading').fadeOut();

							// hide form
							form.fadeOut();

							// show thank you message
							$('#newsletter-section .newsletter-message').html('<p class="thankyou">Thank you for subscribing!</p>').fadeIn();
						}
					},
				});
			});
		})(jQuery);
	},
};
export default SiteGeneral;
